export const IDENTIFIER_VIEW_FIELDS = Object.freeze(['mailbox', 'assignee', 'team', 'tag']);
export const IDENTIFIER_VIEW_OPERATORS = Object.freeze(['IS', 'IS_NOT', 'IN', 'NOT_IN', 'EXISTS']);

export function identifierViewConditionError(condition) {
  if (!IDENTIFIER_VIEW_FIELDS.includes(condition.field)) return null;
  if (!IDENTIFIER_VIEW_OPERATORS.includes(condition.operator)) return 'Operatore non valido per questo filtro.';
  if (condition.operator === 'EXISTS') return typeof condition.value === 'boolean' ? null : 'Seleziona Sì oppure No.';
  const values = Array.isArray(condition.value) ? condition.value : [condition.value];
  if (!values.length) return 'Seleziona almeno un valore per il filtro.';
  if (!['IN', 'NOT_IN'].includes(condition.operator) && Array.isArray(condition.value)) return 'Seleziona un solo valore per il filtro.';
  const valid = values.every((value) => value === null || (typeof value === 'string' && (/^[a-f0-9]{24}$/i.test(value) || (condition.field === 'assignee' && value === 'CURRENT_USER'))));
  return valid ? null : 'Seleziona un valore valido per il filtro.';
}
